export default "/DAI.4a55edcc1c98d49eda8b087551399e74.svg";